import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhInputComponent } from './ph-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { PhDatepickerComponent } from './components/ph-datepicker/ph-datepicker.component';
import { PhCheckboxComponent } from './components/ph-checkbox/ph-checkbox.component';
import { PhRadioComponent } from './components/ph-radio/ph-radio.component';
import { PhAutocompleteGoogleMapComponent } from './components/ph-autocomplete-google-map/ph-autocomplete-google-map.component';
import { BaseValidationComponent } from '@shared/components/ph-input/components/base-validation.component';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from 'src/app/app.functions';

@NgModule({
  declarations: [
    PhInputComponent,
    PhDatepickerComponent,
    PhCheckboxComponent,
    PhRadioComponent,
    PhAutocompleteGoogleMapComponent,
    BaseValidationComponent,
  ],
  exports: [
    PhInputComponent,
    PhRadioComponent,
    BaseValidationComponent,
    PhAutocompleteGoogleMapComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    FormsModule,
    AngularMyDatePickerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
  ],
})
export class PhInputModule {}
